import {Injectable, inject} from '@angular/core'
import {firstValueFrom} from 'rxjs'
import {Endpoints} from '@models/endpoints'
import {UVEApiService} from '@service/uve/api.service'
import {PacksProduct, PromotionalPacks} from '../interfaces/promotional-pack.interface'
import {PromotionalPacksService} from './promotional-packs.service'

@Injectable({
  providedIn: 'root',
})
export class PromotionalPacksEmbeddedService extends PromotionalPacksService {
  private readonly uveApiService = inject(UVEApiService)
  override getPacks = async (outletId: string): Promise<PromotionalPacks[]> => {
    try {
      const packs = this.uveApiService.get(Endpoints.GET_PKPS_BY_CUSTOMER, {
        customerId: outletId,
      })
      return ((await firstValueFrom(packs)) as PromotionalPacks[]) ?? []
    } catch {
      return []
    }
  }

  override getPack = async (id: string, customerId?: string): Promise<PromotionalPacks> => {
    try {
      const pack = await this.uveApiService.getPromise(Endpoints.GET_PKP_DETAILS, {
        offerId: id,
        customerId: customerId,
      })
      return pack as PromotionalPacks
    } catch (error) {
      throw new Error(`Error al obtener el pack: ${error instanceof Error ? error.message : String(error)}`)
    }
  }

  override getPackProduct = async (
    packId: string,
    packProductIdentifier: string,
    customerId?: string
  ): Promise<PacksProduct> => {
    const pack = await this.getPack(packId, customerId)
    return pack.products.find(p => p.codeByManufacturer === packProductIdentifier)
  }

  override getHeaderPack = async (packId: string): Promise<PromotionalPacks> => null
}
